import script from "./new_comment_popup.vue?vue&type=script&setup=true&lang=js"
export * from "./new_comment_popup.vue?vue&type=script&setup=true&lang=js"

import "./new_comment_popup.vue?vue&type=style&index=0&id=0b93333f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b93333f"]])

export default __exports__